import axios from 'axios'

function getOrigin() {
  if (window.location.hostname === 'localhost') {
    return process.env.API_URL
  } else {
    return window.location.origin + '/api'
  }
}

export default axios.create({
  baseURL: getOrigin(),
  withCredentials: true,
  params: {
    secret_key: '12389FJAF8u0ufjsHHK3010283019SFAC',
  },
})



// WEBPACK FOOTER //
// ./src/lib/utils/http.js